<template>
  <div class="d-flex flex-column justify-space-between h-100 bg-blue-grey-darken-4">
    <div class="d-flex flex-column justify-center align-center w-100">
      <img
        :src="require('@/assets/outpacking-logo.svg')"
        alt="Outpacking Logo"
        class="w-75"
      />

      <!-- Navigation List -->
      <v-list class="w-100">
        <v-list-item-group
          v-model="selectedItem"
          color="primary"
          active-class="v-item--active"
        >
          <v-list-item
            v-for="(item, index) in navItems"
            :key="index"
            :to="item.route"
            link
          >
            <div class="d-flex align-center ga-1 w-100">
              <v-icon>{{ item.icon }}</v-icon>
              {{ item.title }}
            </div>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import {NAVBAR_OPTIONS} from "@/helpers/constants/app.constants";
import {sortByNumber} from "@/helpers/services/app.services";

export default {

  data: () => ({
    selectedItem: null,
  }),

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['userFullName', 'isAdminUser', 'isRequesterUser']),

    navItems() {
      return sortByNumber(Object.values(NAVBAR_OPTIONS).map((option) => {
        return {
          title: option.displayName,
          icon: option.icon,
          route: { name: option.name },
          displayOrder: option.displayOrder,
        }
      }), 'displayOrder')
      .filter((item) => {
        // Hide UserView from non-admin users
        if (item.route.name === NAVBAR_OPTIONS.USER_VIEW.name && !this.isAdminUser) {
          return false;
        }
        
        // Hide ApprovalView and FinanceView from general users
        if (this.isRequesterUser && (
          item.route.name === NAVBAR_OPTIONS.APPROVAL_VIEW.name ||
          item.route.name === NAVBAR_OPTIONS.FINANCE_VIEW.name
        )) {
          return false;
        }
        
        return true;
      })
    }
  },

  mounted() {
    this.initApp();
  },

  methods: {
    ...mapActions('user', ['logout']),
    ...mapActions(['initApp']),
    
    capitalizeFirstLetter(name) {
      return name.charAt(0).toUpperCase() + name.slice(1);
    },

    async onLogout() {
      const { success } = await this.logout();

      if (success) {
        this.$router.push({ name: 'SignPage'})
      }
    }
  }
}
</script>